<template>
  <div class="d-flex min-height align-items-center empty-screen">
    <div class="container-fluid px-4 mx-2 text-center">
      <div>
        <i class="material-icons">report_problem</i>
      </div>
      <p>{{ text }}</p>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    text: String
  }
};
</script>

<style scoped></style>
